export enum ApiResources {
  AcceptBetaVersionTerms = "Users/AcceptBetaVersionTerms",
  ChangePassword = "Auth/ChangePassword",
  ChangeSelectedCompany = "Auth/ChangeSelectedCompany",
  CompanyCards = "/CompanyCards",
  CompanyCardReaderFileVersions = "CompanyCardReaderFile/Versions",
  CompanyList = "Users/Companies",
  Companies = "companies",
  CompaniesDeleteConfirmation = "Companies/DeleteConfirmation",
  CompaniesLzCode = "Companies/LZ",
  CompaniesMove = "Companies/Move",
  CompaniesMoveOptions = "Companies/Move/Options",
  CompaniesParent = "Companies/parent",
  CompaniesSettings = "Companies/Settings",
  CreateToken = "Auth/CreateToken",
  CreateTwoFactorToken = "Auth/CreateTwoFactorToken",
  CreateTwoFactorTokenEmail = "Auth/CreateTwoFactorTokenEmail",
  CreateWebsocketToken = "Auth/CreateWebsocketToken",
  Logout = "Auth/Logout",
  CreditsLoan = "Credits/Loan",
  CreditsReport = "Credits/Report",
  DashboardCompanyCards = "Dashboard/CompanyCards",
  DashboardCompanyCardsStatus = "Dashboard/CompanyCardsStatus",
  DashboardCompanyCardsExpirySummary = "Dashboard/CompanyCardsExpirySummary",
  DashboardCredits = "Dashboard/Credits",
  DashboardDevices = "Dashboard/Devices",
  DashboardDriverDownloads = "Dashboard/DriverDownloads",
  DashboardVehicleDownloads = "Dashboard/VehicleDownloads",
  DownloadsHistory = "DownloadsHistory",
  DisableTwofactor = "Auth/DisableTwoFactor",
  DownloadVehicleFiles = "VehicleFiles/Download",
  DriversCount = "Drivers/Count",
  DriverSchedules = "DriverSchedules",
  DriverSchedulesApply = "DriverSchedules/Apply",
  DriverSchedulesApplyToAll = "DriverSchedules/ApplyToAll",
  DriverSchedulesQuickDownload = "DriverSchedules/Quick",
  DriverSchedulesQuickDownloadBulk = "DriverSchedules/Quick/Bulk",
  DriversExport = "Drivers/Export",
  DriversImport = "Drivers/Import",
  EmailRecipients = "EmailRecipients",
  EnableTwofactor = "Auth/EnableTwoFactor",
  FindVehicle = "Vehicles/Find",
  GenerateTwoFactorKey = "Auth/GenerateTwoFactorKey",
  IntegrationsSftp = "Integrations/Sftp",
  IntegrationsEnabled = "Integrations/Enabled",
  IntegrationsApiCredentialsEnabled = "Integrations/ApiCredentials/Enabled",
  IntegrationsApiCredentials = "Integrations/ApiCredentials",
  IntegrationsAnalysisProviders = "Integrations/AnalysisProviders",
  InviteUser = "Users/Invite",
  NewsItems = "NewsItems",
  RefreshToken = "Auth/RefreshToken",
  Repeat = "Repeat",
  ResetPassword = "Auth/ResetPassword",
  SendResetPasswordLink = "Auth/SendResetPasswordLink",
  Users = "Users",
  UsersCreateInvited = "Users/CreateInvited",
  UsersInvitationsCancel = "Users/Invitations/Cancel",
  UsersInvitationsValidate = "Users/Invitations/Validate",
  UsersInvitationsResend = "Users/Invitations/Resend",
  UsersMe = "Users/Me",
  UsersRoles = "Users/Roles",
  UsersSettings = "Users/Settings",
  UsersSettingsFileFormats = "Users/Settings/FileFormats",
  UsersTutorials = "Users/Tutorials",
  VehiclesBulkActivate = "Vehicles/BulkActivate",
  VehiclesCount = "Vehicles/Count",
  VehiclesImport = "Vehicles/Import",
  VehiclesExport = "Vehicles/Export",
  VehiclesLiveStatus = "Vehicles/LiveStatus",
  VehiclesLiveStatuses = "Vehicles/LiveStatuses",
  VehicleSchedules = "VehicleSchedules",
  VehicleSchedulesApply = "VehicleSchedules/Apply",
  VehicleSchedulesBulkApply = "VehicleSchedules/Bulk/Apply",
  VehicleSchedulesApplyToAll = "VehicleSchedules/ApplyToAll",
  VehicleSchedulesQuickDownload = "VehicleSchedules/Quick",
  VehicleSchedulesQuickDownloadBulk = "VehicleSchedules/Quick/Bulk",
  VerifyEmailOtp = "Auth/VerifyEmailOtp"
}

export enum AlertMessageResources {
  User = "User"
}
